export default {
  system: '/system',
  auth: '/auth',
  ocean: '/ocean',
  vip: '/vip',
  comBasic: '/business-basic',
}
